module.exports = __webpack_public_path__ + "images/lada_small0e8e57ade779572d0a93eec6e7ec6f76.png";